import FileSaver from 'file-saver';
import moment from 'moment';
import CountUp from 'react-countup';
import * as Session from './session';
import md5 from 'md5';

const Utils = {
  /**
   * Flat Map 根据相应的字断
   * @param arr 源数组
   * @param step 层级
   * @param clear 是否删除原层级数据
   * @returns {[]|*[]}
   */
  flatMap(arr, step = 'children', clear = false) {
    const flatArr = [];
    const iterate = function(item) {
      flatArr.push(item);
      if(item[step]) {
        item[step].forEach(v => {
          iterate(v);
        });
        if(clear) {
          delete item[step];
        }
      }
    };
    if(!arr || !(arr instanceof Array)) {
      return [];
    } else {
      arr.forEach(iterate);
      return flatArr;
    }
  },

  /**
   * unFlat Map 根据相应的字断
   * @param items 扁平数组
   * @param key 父类id key
   * @param parentId 父类id key
   * @param child 子类 key
   * @returns {[]}
   */
  unFlatMap(items, key = 'id', parentId = 'parentId', child = 'children') {
    const result = [];   // 存放结果集
    const itemMap = {};  //
    for(const item of items) {
      const id = item[key];
      const pid = item[parentId];

      if(!itemMap[id]) {
        itemMap[id] = { [child]: [] };
      }

      itemMap[id] = { ...item, [child]: itemMap[id][child] };

      const treeItem =  itemMap[id];

      if(pid === 0) {
        result.push(treeItem);
      } else {
        if(!itemMap[pid]) {
          itemMap[pid] = { [child]: [] };
        }
        itemMap[pid][child].push(treeItem);
      }
    }
    return result;
  },

  params2json(params = '', slice = '&') {
    return params.split(slice).reduce((acc, item) => {
      let arr = item.split('=');
      return item ? { ...acc, ...{ [arr[0]]: arr[1] }} : acc;
    }, {});
  },

  handlerOptions(option, textKey, valueKey) {
    if(!option) throw new Error('option can not be undifend or null');
    const optionProps = {};
    if(typeof option === 'object') {
      optionProps.disabled = option.disabled || false;
      option = {
        [textKey]: option[textKey],
        [valueKey]: option[valueKey]
      };
    } else {
      option = { [textKey]: option, [valueKey]: option };
    }
    return { option, optionProps };
  },
  getFileExt(fileName = '') {
    const index = fileName.lastIndexOf('.');
    const regExp = new RegExp('^[A-Za-z0-9]+$');
    if(index > 0 && regExp.test(fileName.slice(index + 1))) {
      fileName = fileName.toLowerCase();
      return fileName.substring(index + 1);
    }
    return '';
  },
  // 导出文件
  exportFile(url = '', name = '') {
    if(!url) return;
    return FileSaver.saveAs(url, `${`${name}`.trim()}.${Utils.getFileExt(url)}`);
  },

  isNotEmpty(value) {
    switch (typeof value) {
      case 'undefined': {
        return false;
      }

      case 'string': {
        return value.length !== 0;
      }

      case 'object': {
        if(Array.isArray(value)) {
          return value.length !== 0;
        } else if(value === null) {
          return false;
        } else {
          return Object.keys(value).length !== 0;
        }
      }

      default: {
        return true;
      }
    }
  },
  /**
   * 获取上一周期时间
   */
  computedMonth(createDate, periodType) {
    const startList = createDate.split('-');
    const sYear = +startList[0];
    const sMonth = +startList[1];
    const formatCount = (count) => {
      return count < 10 ? `0${count}` : count;
    };

    let lastCreateDate = '';
    if(periodType === 'quarter') {
      if(sMonth === 1) {
        lastCreateDate = `${sYear - 1}-10-01`;
      } else {
        lastCreateDate = `${sYear}-${formatCount(sMonth - 3)}-01`;
      }
    } else if(periodType === 'week') {
      const { Y, M, D } = this.getDate(new Date(createDate).getTime() - 1000 * 60 * 60 * 24 * 7);
      lastCreateDate = `${Y}-${M}-${D}`;
    } else {
      if(sMonth === 1) {
        lastCreateDate = `${sYear - 1}-12-01`;
      } else {
        lastCreateDate = `${sYear}-${formatCount(sMonth - 1)}-01`;
      }
    }
    return {
      lastCreateDate
    };
  },
  /**
   * 上周时间范围
   */
  handleGetPrevWeek() {
    const Time = new Date();
    let weekNum = Time.getDay();
    weekNum = weekNum === 0 ? 7 : weekNum;
    let lastDate = new Date(Time.getTime() - weekNum * 24 * 60 * 60 * 1000);
    let fitstDate = new Date(Time.getTime() - (weekNum + 6) * 24 * 60 * 60 * 1000);
    let startDate = `${fitstDate.getFullYear()}-${
      fitstDate.getMonth() + 1 < 10
        ? '0' + (fitstDate.getMonth() + 1)
        : fitstDate.getMonth() + 1
    }-${
      fitstDate.getDate() < 10
        ? '0' + fitstDate.getDate()
        : fitstDate.getDate()
    }`;
    let endDate = `${lastDate.getFullYear()}-${
      lastDate.getMonth() + 1 < 10
        ? '0' + (lastDate.getMonth() + 1)
        : lastDate.getMonth() + 1
    }-${
      lastDate.getDate() < 10 ? '0' + lastDate.getDate() : lastDate.getDate()
    }`;
    return {
      startDate, endDate
    };
  },

  //保留搜索页
  checkSearchOptions(searchOptions) {
    const pathname = window.location.pathname;
    const sessionKey = `${pathname}-searchOptions`;
    if(Session.get(sessionKey)) {
      return JSON.parse(Session.get(sessionKey));
    } else {
      return Session.put(sessionKey, JSON.stringify(searchOptions));
    }
  },

  //保留搜索页
  /**
   * 传了searchOptions就会存储，不传就是读取
   * @param searchOptions
   * @returns {any|void}
   */
  checkSearchOptions1(searchOptions) {
    const pathname = window.location.pathname;
    const sessionKey = `${pathname}-searchOptions`;
    if(searchOptions) {
      return Session.put(sessionKey, JSON.stringify(searchOptions));
    } else if(Session.get(sessionKey)) {
      return JSON.parse(Session.get(sessionKey || '{}'));
    }
  },

  searchAssign(origin = {}, values = {}, ...params) {
    let tempValue = Object.assign({}, values);
    if(params && params.length) {
      params.forEach((item) => {
        Object.assign(tempValue, item);
      });
    }
    if(Object.keys(tempValue).length) {
      for(let key in tempValue) {
        if(this.isNotEmpty(tempValue[key]) && this.isNotEmpty(String(tempValue[key]))) {
          origin[key] = tempValue[key];
        } else {
          delete origin[key];
        }
      }
    } else {
      for(let key in origin) {
        if(!this.isNotEmpty(origin[key])) {
          delete origin[key];
        }
      }
    }
    return origin;
  },

  /**
   * 先过滤对象中的空属性，再合并，使用方法类似于Object.assign，不对第一个参数做修改，而是将结果作为新的对象返回
   * @param args
   * @returns {{}}
   */
  filterMerge(...args) {
    return Object.assign.apply(null, args.map((object) => {
      return Object.keys(object).reduce((obj, key) => {
        const value = object[key];
        if(Utils.isNotEmpty(value) && value !== 'undefined') {
          obj[key] = value;
        }
        return obj;
      }, {});
    }));
  },

  json2params(json, slice = '&') {
    return Object.keys(json).reduce((acc, item) => {
      return String(acc) + item + '=' + json[item] + slice;
    }, '').slice(0, -1);
  },

  formatQuery2QueryStr(query = {}) {
    let queryStr = '';
    const filteredQuery = Utils.filterMerge(query);
    if(Utils.isNotEmpty(filteredQuery)) {
      queryStr = '?' + Utils.json2params(filteredQuery);
    }
    return queryStr;
  },

  /**
   * 链接拼参数
   * @param url 可以是带query的也可以是不带的
   * @param params 拼的参数对象
   * @returns {string}
   */
  padQuery(url = '', params = {}) {
    const [pathname, queryStr] = url.split('?');
    let tempQuery = Utils.filterMerge(Object.assign({}, Utils.params2json(queryStr), Utils.filterMerge(Object.assign({}, params))));
    let searchQuery = Utils.formatQuery2QueryStr(tempQuery);
    return `${pathname}${searchQuery}`;
  },
  // 权限管理处理数据信息
  handleDataInfo(data = [], type = 1) {
    let list = [];
    if(type === 1) {
      data.forEach(item => {
        const infoFirst = {};
        infoFirst.title = item.name;
        infoFirst.key = item.id;
        if(item.childList && item.childList.length > 0) {
          infoFirst.children = [];
          item.childList.forEach(v => {
            const infoTwo = {};
            infoTwo.title = v.name;
            infoTwo.key = v.id;
            infoFirst.children.push(infoTwo);
          });
        }
        list.push(infoFirst);
      });
    } else {
      data.forEach(item => {
        list.push(item.id);
        if(item.childList && item.childList.length > 0) {
          item.childList.forEach(v => {
            list.push(v.id);
          });
        }
      });
    }
    return list;
  },
  getDate(time) {
    if(time && !(+time > 0)) {
      let [tDate, tTime] = time.split(' ');
      tDate = tDate.replace(/[^\d]/g, '/');
      time = tTime ? `${tDate} ${tTime}` : `${tDate}`;
    }
    const d = time ? new Date(time) : new Date();
    const M = d.getMonth() + 1;
    const D = d.getDate();
    const h = d.getHours();
    const m = d.getMinutes();
    const s = d.getSeconds();
    return {
      Y: d.getFullYear(),
      M: M < 10 ? '0' + M : M,
      W: d.getDay(), //周几
      D: D < 10 ? '0' + D : D,
      h: h < 10 ? '0' + h : h,
      min: m < 10 ? '0' + m : m,
      s: s < 10 ? '0' + s : s,
      ms: d.getMilliseconds()
    };
  },
  getSizeByByte(size) {
    if(typeof size !== 'number') {
      size = Number(size);
      // throw Error("Argument Must Be A Number")
    }
    const KBUNIT = 'KB', MBUNIT = 'MB', UNITSIZE = 1024;
    let kb = size / UNITSIZE,
      mb = size / (UNITSIZE * UNITSIZE);
    return mb > 0.01
      ? parseFloat(mb).toFixed(2) + MBUNIT
      : parseFloat(kb).toFixed(2) + KBUNIT;
    // return parseFloat(mb).toFixed(2) + MBUNIT;
  },
  /**
   * 三位数内的阿拉伯数字转换
   * @param num
   * @returns {string}
   */
  numberConvertToUppercase(num) {
    num = Number(num);
    let upperCaseNumber = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '百', '千', '万', '亿'];
    let length = String(num).length;
    if(length === 1) {
      return upperCaseNumber[num];
    } else if(length === 2) {
      if(num === 10) {
        return upperCaseNumber[num];
      } else if(num > 10 && num < 20) {
        return '十' + upperCaseNumber[String(num).charAt(1)];
      } else {
        return upperCaseNumber[String(num).charAt(0)] + '十' + upperCaseNumber[String(num).charAt(1)].replace('零', '');
      }
    }
  },
  // 处理数据
  formatNumber(num, duration = 0, start = 0.8, fixedLength = 2, unit) {
    if(!num) {
      return '--';
    }
    let value = num || 0;
    // if(num >= 1e3 && num < 1e4) {
    //   value = <span className="formatNumber">{(num / 1e3).toFixed(fixedLength)}<span className="formatNumber-unit">K</span></span>;
    // } else
    if(num > 0 && num < 1e4) {
      value = <span className="formatNumber">
        <CountUp
          redraw={false}
          start={num * start}
          end={num}
          decimals={num % 1 === 0 ? 0 : fixedLength}
          duration={duration}
        />
        <span className="formatNumber-unit">{unit}</span>
      </span>;
    }
    if(num >= 1e4 && num < 1e8) {
      value = <span className="formatNumber">
        <CountUp
          redraw={false}
          start={(num / 1e4).toFixed(fixedLength) * start}
          end={(num / 1e4).toFixed(fixedLength)}
          decimals={fixedLength}
          duration={duration}
        />
        <span className="formatNumber-unit">{unit || 'W'}</span></span>;
    } else if(num >= 1e8) {
      value = <span className="formatNumber">
        <CountUp
          redraw={false}
          start={(num / 1e8).toFixed(fixedLength) * start}
          end={(num / 1e8).toFixed(fixedLength)}
          decimals={fixedLength}
          duration={duration}
        />
        <span className="formatNumber-unit">{unit || '亿'}</span></span>;
    }
    return value;
  },
  formatNumber3(num, fixedLength = 2) {
    if(Number.isNaN(+num)) {
      return num;
    }
    const isNegative = num < 0;
    let value = Math.abs(num) || 0;
    if(value >= 1e4 && value < 1e8) {
      value = `${isNegative ? '-' : ''}${(value / 1e4).toFixed(fixedLength)}W`;
    } else if(value >= 1e8) {
      value = `${isNegative ? '-' : ''}${(value / 1e8).toFixed(fixedLength)}亿`;
    } else {
      value = num;
    }
    return value;
  },
  // 23456 => 234,56
  formatNumber2(num = 0) { //取整，三行逗号隔开
    num = Math.floor(num);//向下取整，
    num = num.toString();
    let len = num.length,
      r = len % 3;
    if(len <= 3) {
      return num;
    }
    num = r > 0 ? num.slice(0, r) + ',' + num.slice(r, len).match(/\d{3}/g).join(',') : num.slice(r, len).match(/\d{3}/g).join(',');
    return num;
  },
  formatBeforeTime(time) {
    const result = parseInt(time / 60);
    if(result === 0) {
      return '刚刚';
    } else if(result < 60) {
      return result + '分钟前';
    } else if(result < 60 * 24) {
      return parseInt(result / 60) + '小时前';
    } else if(result < 60 * 24 * 7) {
      return parseInt(result / 60 / 24) + '天前';
    } else if(result < 60 * 24 * 30) {
      return parseInt(result / 60 / 24 / 7) + '周前';
    } else if(result < 60 * 24 * 30 * 12) {
      return parseInt(result / 60 / 24 / 30) + '月前';
    } else if(result < 60 * 24 * 30 * 12 * 100) {
      return parseInt(result / 60 / 24 / 30 / 12) + '年前';
    }
  },
  // 当前榜单数据月份
  getDataMonth() {
    const now = moment();
    // 1号之后取上个月
    if(now.date() >= MONTH_SUB_SEPARATOR_DAY) {
      return now.subtract('month', 1).format('M月');
    }
    // 30号之前取上上月
    return now.subtract('month', 2).format('M月');
  },
  // 处理时间
  handleDate(type = 0) {
    const nowDay = Number(`${moment().format('DD')}`);
    const monthSub = nowDay >= MONTH_SUB_SEPARATOR_DAY ? 1 : 2;
    if(type === 0) {
      // 近3个月
      return [
        moment().subtract(2 + monthSub, 'months').format(formatType),
        moment().subtract(monthSub, 'months').format(formatType)
      ];
    } else if(type === 1) {
      // 近6个月
      return [
        moment().subtract(5 + monthSub, 'months').format(formatType),
        moment().subtract(monthSub, 'months').format(formatType)
      ];
    } else if(type === 2) {
      // 近一年
      return [
        moment().subtract(11 + monthSub, 'months').format(formatType),
        moment().subtract(monthSub, 'months').format(formatType)
      ];
    } else if(type === 3) {
      // 今年以来
      return [
        moment().startOf('year').format(formatType),
        moment().subtract(monthSub, 'months').format(formatType)
      ];
    }
  },
  // 加入pk动画
  addPKAnimation(type, id) {
    const demo = document.getElementById(type);
    const node = document.getElementById(id);
    // 绘制一个小球
    let ballDom = Utils.drawBall();
    // 设置初始位置
    ballDom.style.top = `${demo.getBoundingClientRect().y}px`;
    ballDom.style.left = `${demo.getBoundingClientRect().x}px`;
    document.body.appendChild(ballDom);
    // 设置抛物线动画的结束位置，加上transition属性，这里的top 和 left要和之前设置的对应
    setTimeout(() => {
      ballDom.style.top = `${node.getBoundingClientRect().y + 25}px`;
      ballDom.style.left = `${node.getBoundingClientRect().x + 80}px`;
    }, 10);
    // 等动画使用的图标到达指定位置后，使其消失，setTimeout的时间为动画时间+上一个setTimeout时间
    setTimeout(() => {
      ballDom.setAttribute('style', 'display: none');
    }, 1100);
  },
  drawBall() {
    let ballDom = document.createElement('div');
    ballDom.style.width = '20px';
    ballDom.style.height = '20px';
    ballDom.style.background = '#ff4d4f';
    ballDom.style.borderRadius = '50%';
    ballDom.style.position = 'fixed';
    ballDom.style.zIndex = 1000;
    ballDom.style.transition = 'left ease-out 1s,top ease-in 1s';
    return ballDom;
  },
  sortData(data = [], type = '') {
    let list = [];
    if(data.length) {
      list = JSON.parse(JSON.stringify(data)).sort((v1, v2) => {
        const a = String(parseInt(v1[type])) !== 'NaN' ? parseInt(v1[type]) : -1;
        const b = String(parseInt(v2[type])) !== 'NaN' ? parseInt(v2[type]) : -1;
        return a - b;
      });
    }
    return list;
  },
  contrastData(data, value, type = '') {
    let list = [];
    list = data.map(item => item[value] || 0);
    list = list.sort((a, b) => b - a);
    if(type) {
      return list[list.length - 1];
    }
    return list[0];
  },
  isUrl(url) {
    return /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/.test(url);
  },
  getFileId(file = {}) {
    const ext = Utils.getFileExt(file.name);
    const lastModified = Number(new Date(file.lastModified || file.lastModifiedDate || ''));
    return md5(String(ext) + lastModified + file.size);
  },
  getBookName(bookInfo) {
    const fields = ['togetherbookName', 'bookTitle', 'bookName', 'subbookName', 'volumebookName', 'volumebookNo'];
    const data = fields.map(item => bookInfo[item]).filter(item => item);
    const splitWords = data.join(' ').split(' ');
    return Array.from(new Set(splitWords)).join(' ');
  },
  getMonth(type) {
    // const type = ['pre', 'now', 'next'];
    let month = 12;
    let current = new Date().getMonth();
    // 上一个月
    if(type === 'pre' && current) {
      month = current;
    }
    // 当前月
    if(type === 'now') {
      month = current + 1;
    }
    return month;
  },
  getMonthSub() {
    const nowDay = Number(`${moment().format('DD')}`);
    const monthSub  = nowDay >= MONTH_SUB_SEPARATOR_DAY ? 1 : 2;
    return monthSub;
  },
  getUseMonth() {
    const monthSub  = Utils.getMonthSub();
    return moment().subtract(monthSub, 'month').format('M');
  },

  // 获取某某年截至今年的所有年份
  getYearsToNow(startYear = 2022) {
    //获取到从那一年开始
    let smallYears = startYear;
    //获取当前时间
    let date = new Date();
    let nowYears = date.getFullYear();
    let Years = nowYears - smallYears;
    let arrYear = [];
    for(let i = 0; i <= Years; i++) {
      arrYear.push(nowYears--);
    }
    return arrYear;
  },

  // 数组去重
  dumpArr(arr) {
    return arr.reduce((prev, curr) => {
      if(prev.includes(curr)) {
        return prev;
      }
      return prev.concat([curr]);
    }, []);
  },

  /**
   * 数据区间归一方法
   * @param x 需要被归一化的数据
   * @param xArr 需要归一的数据集合
   * @param y_min 归一化的区间下限
   * @param y_max 归一化的区间上限
   */
  normalization(x, xArr = [], y_min = 2, y_max = 32) {
    // 计算最大值
    let x_max = Math.max(...xArr);
    // 计算最小值
    let x_min = Math.min(...xArr);

    return (y_max - y_min) * (x - x_min) / (x_max - x_min) + y_min;

  },

  getHasDataMonthSub() {
    const nowDay = Number(`${moment().format('DD')}`);
    const monthSub  = nowDay > 15 ? 1 : 2;
    return monthSub;
  },
  getHasDataMonth() {
    const monthSub  = Utils.getHasDataMonthSub();
    return moment().subtract(monthSub, 'month').format('M');
  }
};

export default Utils;

const formatType = 'YYYY-MM-01';

const MONTH_SUB_SEPARATOR_DAY = 17;
